export type QueryExternalServiceInput<T extends AvailableExternalQueries> = {
  query: T;
  inputData: ExternalQueryParameters[T];
};

export type QueryInternalServiceInput<T extends AvailableInternalQueries> = {
  tenantId: number;
  query: T;
  inputData: InternalQueryParameters[T];
};

// Queries habilitadas
export enum AvailableExternalQueries {
  GET_FINNEGANS_PRODUCT = 'getProductByCode',
  GET_FINNEGANS_PRODUCTS = 'getProductsByCode',
  GET_DIMENSION_VALUES = 'getDimensionValues',
  GET_RELATED_DOCUMENTS = 'getRelatedDocuments',
  GET_DIMENSIONS = 'getDimensions',
  GET_BUY_ORDERS = 'getBuyOrders',
  GET_DISTRIBUTIONS = 'getDistributions',
  GET_BANK_OPERATION = 'getBankOperationTypes',
  GET_PAY_ORDER_ACCOUNTS = 'getPayOrdenAccounts',
  GET_PROVIDER = 'getProvider',
  GET_PAYMENT_TERMS = 'getPayConditions',
  GET_RECEPTIONS = 'getReceptions',
  GET_SUBCONTRACTOR_CERTIFICATES = 'getSubcontractorCertificate',
  GET_VENDOR_DATA_BY_EMAIL = 'getVendorDataByEmail',
  GET_BRANCH_LIST = 'getBranchList',
}

export enum AvailableInternalQueries {
  GET_RECEIPT_HEADER = 'getReceipt',
}

export enum TipoRol {
  Origen = 0,
  Destino = 1,
}

// Parámetros para cada query
export interface ExternalQueryParameters {
  [AvailableExternalQueries.GET_FINNEGANS_PRODUCT]: {
    productCode: string;
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_DIMENSION_VALUES]: {
    dimensionCodes: string[];
    // documentCode: string; POR BACKEND
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_FINNEGANS_PRODUCTS]: {
    productCodes: string[];
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };

  [AvailableExternalQueries.GET_BUY_ORDERS]: {
    buyOrderCodes: string[];
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_RELATED_DOCUMENTS]: {
    providerCode: string;
    rolType: TipoRol;
    paymentMethod: string;
    workflow: string | undefined;
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
    // documentCode: string; POR BACKEND
    // workflowCode: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_DIMENSIONS]: {
    productCodes: string[];
    paymentMethod: string;
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
    // documentCode: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_DISTRIBUTIONS]: {
    dimensionCodes: string[];
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_BANK_OPERATION]: {
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_PAY_ORDER_ACCOUNTS]: {
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_PROVIDER]: {
    providerCode: string;
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_PAYMENT_TERMS]: {
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_RECEPTIONS]: {
    receptionsCodes: string[];
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_SUBCONTRACTOR_CERTIFICATES]: {
    certificatesCodes: string[];
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
  [AvailableExternalQueries.GET_VENDOR_DATA_BY_EMAIL]: {
    webhookURL: string;
    payload: {
      data: {
        from_email: string;
        receipt_detail: any[];
      };
    };
    clientId: string;
    clientSecret: string;
    tenant_id: number;
  };
  [AvailableExternalQueries.GET_BRANCH_LIST]: {
    // clientId: string; POR BACKEND
    // clientSecret: string; POR BACKEND
  };
}

export interface InternalQueryParameters {
  [AvailableInternalQueries.GET_RECEIPT_HEADER]: { receiptHeaderId: number };
}
